import { Button, Flex, OldText, breakpoints } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'
import styled from 'styled-components'

const Image = styled.img`
  height: auto;
  width: 8rem;
  margin-bottom: 2rem;

  @media screen and (min-width: ${breakpoints.medium}) {
    width: 10rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    width: 12rem;
    margin-bottom: 2.5rem;
  }
`

const EmptyCart: FC = () => {
  const { t } = useTranslation('other')
  const router = useRouter()
  return (
    <Flex
      py={{ _: '3rem', large: '2.5rem 8.75rem' }}
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
    >
      <Image src="/images/bg_shopping_bag.svg" alt="empty shopping bag" />
      <OldText variant="large" mb={{ _: '2rem', large: '3rem' }}>
        {t('noItemsInShoppingCart')}
      </OldText>
      <Button variant="dark" onClick={() => router.back()}>
        {t('continueShopping')}
      </Button>
    </Flex>
  )
}

export default EmptyCart
